import { useEffect, useState } from 'react';

import { scrollbarWidth } from '../utils/scrollbarWidth';

/**
 * Hook that detects the size of the browser's scrollbar
 */
const useScrollbarWidth = () => {
    const [width, setWidth] = useState(scrollbarWidth());

    // ensures the scrollbar width in case the hook is called before the DOM is ready
    useEffect(() => {
        if (typeof width !== 'undefined') {
            return undefined;
        }

        const requestId = requestAnimationFrame(() => {
            setWidth(scrollbarWidth());
        });

        return () => cancelAnimationFrame(requestId);
    }, []);

    return width;
};

export default useScrollbarWidth;
